module.exports = __webpack_public_path__ + "img/task148.22d45219.png";